<template>
  <div class="col-sm pt-2">
    <button
      type="button"
      @click="createSimilarPost"
      class="btn btn-outline-primary btn-block"
      :disabled="disabledCreateSimilarButton"
    >
    {{this.i18n.buttonText}}
    </button>
  </div>
</template>

<script>

import { uuid } from '../utils/uuid';
import Url from 'domurl';

  // import Translations from "./insert-me-to-translate.vue";
export default {

  name: 'CreateSimilar',
  props: {
  initCreateSimilarUrl: {
    type: String,
    required: true
  },
  postPrivateCode: {
    type: String,
    required: true
  },
  urlAccountAds: {
    type: String,
    required: true
  },
  canCreateSimilar: {
    type: Boolean,
    default: false
  }
},
  data() {
    return {
      disabledCreateSimilarButton: false,
      creatingSimilar: false,
      i18n: {
              buttonText: gettext('Create similar ad'),
      },
      session: uuid()
    };
  },

  mounted() {
    this.disabledCreateSimilarButton = !this.canCreateSimilar;
  },

  methods: {
    async createSimilarPost() {
      this.disabledCreateSimilarButton = true;
      this.creatingSimilar = true;

      const requestBody = {
        private_code: this.postPrivateCode,
        session: this.session
      };
      const headers = {
        headers: {
          "X-CSRFToken": this.$cookies.get("csrftoken"),
        },
      };

      try {
        const response = await this.$http.post(this.initCreateSimilarUrl, requestBody, headers);

        if (response && response.data && response.data.data && response.data.data.redirection_url) {
            this.redirectToReviewSimilarPostSection(response.data.data.redirection_url);
        } else {
            throw new Error("Invalid response structure");
        }
    } catch (error) {
          window.showErrorTopAlertWithTimer();
          this.disabledCreateSimilarButton = false;
          this.creatingSimilar = false;
    } finally {
        this.disabledCreateSimilarButton = false;
        this.creatingSimilar = false;
    }
    },

    redirectToReviewSimilarPostSection(redirectionUrl) {
      const url = new Url(window.location.href)
      url.path = redirectionUrl;
      url.query.next = this.urlAccountAds
      url.query.session = this.session;
      window.location.href = url.toString();
    },
  },

};
</script>
